
import { Vue } from "vue-property-decorator";

export default Vue.extend({
  name: "headerView",
  components: {},
  computed: {
    isSyariah(): boolean {
      return this.$store.getters.getIsSyariah();
    }
  }
});
